import React from "react";
import { RecoverAccountMFA } from "../../components/RecoverAccountMFA/RecoverAccountMFA";

export const RecoverMFA = () => {
  return <RecoverAccountMFA />;
};
